import ChevronDown from '@eduzz/houston-icons/ChevronDown';
import ChevronUp from '@eduzz/houston-icons/ChevronUp';
import Collapse from '@eduzz/houston-ui/Collapse';
import Table from '@eduzz/houston-ui/Table';
import React, { memo } from 'react';
import { numberToBRL } from 'v2/helpers/money';
import { EFinancialStatementTabs } from 'v2/interfaces/financial';

import type { SomeFinancialStatementTabs, IFinancialEntry } from 'v2/interfaces/financial';

import { useStyles } from './styles';
import ContentInnerTable from '../ContentInnerTable';

interface IProps {
  selected: boolean;
  data: IFinancialEntry;
  index: number;
  handleSelect: Function;
  balanceLabel: string;
  showBlockedDetails?: boolean;
  currentTab?: SomeFinancialStatementTabs;
}

function ContentItem({ selected, data, index, handleSelect, balanceLabel, showBlockedDetails, currentTab }: IProps) {
  const classes = useStyles();

  const formatDate = (dateRaw: string) => new Intl.DateTimeFormat('pt-BR').format(new Date(`${dateRaw}T00:00:00`));

  return (
    <Table.Row data={data} index={index}>
      <Table.Cell className={classes.tableCell}>
        <div className={classes.mainRow} onClick={() => handleSelect(index)}>
          <div>
            <div>
              {showBlockedDetails && 'Bloqueio em '}
              {formatDate(data.transaction_date)}
            </div>
            <div className={classes.entries}>
              <small>{`${data.items} registros`}</small>
            </div>
            {currentTab === EFinancialStatementTabs.STATEMENT && (
              <>
                <div>
                  <small className={classes.valueLabel}>Créditos</small>
                  {typeof data?.positive === 'number' ? numberToBRL(data?.positive) : 'R$ -'}
                </div>
                <div>
                  <small className={classes.valueLabel}>Débitos</small>
                  {typeof data?.negative === 'number' ? numberToBRL(data?.negative) : 'R$ -'}
                </div>
              </>
            )}
            <div>
              <small className={classes.valueLabel}>{balanceLabel}</small>
              {numberToBRL(data.balance)}
            </div>
          </div>
          <div>{!!selected && !showBlockedDetails ? <ChevronUp /> : <ChevronDown />}</div>
        </div>
        {selected && (
          <Collapse visibled={selected}>
            <div className={classes.collapse}>
              <ContentInnerTable transactionDate={data.transaction_date} showBlockedDetails={showBlockedDetails} />
            </div>
          </Collapse>
        )}
      </Table.Cell>
    </Table.Row>
  );
}

export default memo(ContentItem);
